import React from 'react'
import { map } from 'lodash';
import CommonCard from './CommonCard';
import workExperienceData from '../data/work_experience.json';

class WorkExperience extends React.Component{
    render(){
        return(
            <div className = "wholeworkexperiencecontainer">
                {map(workExperienceData.stuff, (data) => (
                    <React.Fragment key={`${data.job}-${data.start}`}>
                        <CommonCard
                            title={data.title}
                            name={data.job}
                            start={data.start}
                            end={data.end}
                            work={data.work}
                            skills={data.skills}
                            media={data.media}
                        />
                        <br />
                    </React.Fragment>
                ))}
            </div>
        );
    }
}
export default WorkExperience
